import { TaskActions } from '../constants/tasks';

export const selectTasks = state => state.common[TaskActions.TaskLists];